import Network from "./network";

export default Network;
